import React from "react";
import { BuyNowAction } from "../shared/PurchaseButtons";
import { CART_TEXTS } from "../../pages/shared/constants";

/**
 * The way to checkout from anywhere that is not the product page.
 *
 * Visually identical to the detail page's buy action (EB-556) — same orange, same pill, same ink —
 * because it is the same decision. The `AddCard` icon it used to carry is gone: the detail page
 * pills have none, and an icon on one of two identical buttons is a difference that means nothing.
 */
type BuyButtonProps = {
  handlePurchase: (() => void) | undefined;
  /**
   * An empty cart is the one case where this leads nowhere — checkout would open on nothing. Note
   * this is not the availability rule from `docs/ordering-flow/README.md` §3.5, which is about
   * never disabling checkout over stock; here there is genuinely no order to make.
   */
  disabled?: boolean;
};

const BuyButton: React.FC<BuyButtonProps> = ({ handlePurchase, disabled = false }) => {
  return (
    <BuyNowAction fullWidth variant="contained" onClick={handlePurchase} disabled={disabled}>
      {CART_TEXTS.checkout}
    </BuyNowAction>
  );
};

export default BuyButton;
